"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
/**
 * Converts number values to a string with a unit.
 */

function valueToString(value) {
  var unit = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'px';
  return typeof value === 'number' ? "".concat(value).concat(unit) : value;
}

exports.default = valueToString;